import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import store from "../utils/storage";
import Login from '@/components/Login'
import MessageList from '@/components/infoData/MessageList'
import MessageDetail from '@/components/infoData/MessageDetail'
import MessageBackDetail from '@/components/infoData/MessageBackDetail'
import AppDownload from '@/components/other/AppDownload'
import Home from '@/components/Home'
import KPIList from '@/components/kpi/KPIList'
import KPIDetail from '@/components/kpi/KPIDetail'
import ModernStack from '@/components/kpi/ModernStack'
import ModernAvgGoods from '@/components/kpi/ModernAvgGoods'
import ModernDay from '@/components/kpi/ModernDay'
import ModernPromotion from '@/components/kpi/ModernPromotion'
import ModernNew from '@/components/kpi/ModernNew'

import TwentyAvgGoods from '@/components/kpi/TwentyAvgGoods'
import TwentyBox from '@/components/kpi/TwentyBox'
import TwentyNew from '@/components/kpi/TwentyNew'
import TwentyStock from '@/components/kpi/TwentyStock'

import MAAvgGoods from '@/components/kpi/MAAvgGoods'
import MABox from '@/components/kpi/MABox'
import MANew from '@/components/kpi/MANew'
import MADisplay from '@/components/kpi/MADisplay'
import WorkLoad from '@/components/kpi/WorkLoad'
import ToTerminal from '@/components/kpi/ToTerminal'
import EightyAvgGoods from '@/components/kpi/EightyAvgGoods'
import EightyGoods from '@/components/kpi/EightyGoods'
import EightyBox from '@/components/kpi/EightyBox'
import AllStock from '@/components/kpi/AllStock'
import AllDisplay from '@/components/kpi/AllDisplay'
import CVSAvg from '@/components/kpi/CVSAvg'
import CVSFreezer from '@/components/kpi/CVSFreezer'
import CVSDisplay from '@/components/kpi/CVSDisplay'
import CVSStock from '@/components/kpi/CVSStock'
import Performance from '@/components/kpi/Performance'
import KpiHome from '@/components/kpi/KpiHome'
import CustomerKpi from '@/components/kpi/CustomerKpi'


import CallCardDetail from '@/components/callPlan/CallCardDetail'



Vue.use(Router)

var options = {
  base: '/web/',
  routes: [
    {
      path: '/',
      redirect:'/home'
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      show: false
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      // component: ()=> import('@/components/Login'),
      show: false
    },
    {
      path: '/messagelist/:uid',
      name: 'MessageList',
      component: MessageList,
      show: false
    },
    {
      path: '/messagedetil/:pid/:uid',
      name: 'MessageDetail',
      component: MessageDetail,
      show: false
    },
    {
      path: '/messagebackdetil/:callcardid/:uid/:msgid',
      name: 'MessageBackDetail',
      component: MessageBackDetail,
      show: false
    },
    {
      path: '/appdownload/:domainid?',
      name: 'AppDownload',
      component: AppDownload,
      props:true,
      show: false
    },
    {
      path: '/kpi/:uid',
      name: 'kpi',
      component: KPIList,
      show: false
    },
    {
      path: '/kpidetail/:type',
      name: 'kpidetail',
      component: KPIDetail,
      show: false
    },
    {
      path: '/ModernStack/:uid/:module/:title',
      name: 'ModernStack',
      component: ModernStack,
      show: false
    },
    {
      path: '/ModernAvgGoods/:uid/:module/:title',
      name: 'ModernAvgGoods',
      component: ModernAvgGoods,
      show: false
    },
    {
      path: '/ModernDay/:uid/:module/:title',
      name: 'ModernDay',
      component: ModernDay,
      show: false
    },
    {
      path: '/ModernPromotion/:uid/:module/:title',
      name: 'ModernPromotion',
      component: ModernPromotion,
      show: false
    },
    {
      path: '/ModernNew/:uid/:module/:title',
      name: 'ModernNew',
      component: ModernNew,
      show: false
    },
    {
      path: '/TwentyAvgGoods/:uid/:module/:title',
      name: 'TwentyAvgGoods',
      component: TwentyAvgGoods,
      show: false
    },
    {
      path: '/TwentyBox/:uid/:module/:title',
      name: 'TwentyBox',
      component: TwentyBox,
      show: false
    },
    {
      path: '/TwentyNew/:uid/:module/:title',
      name: 'TwentyNew',
      component: TwentyNew,
      show: false
    },
    {
      path: '/TwentyStock/:uid/:module/:title',
      name: 'TwentyStock',
      component: TwentyStock,
      show: false
    },
    {
      path: '/MAAvgGoods/:uid/:module/:title',
      name: 'MAAvgGoods',
      component: MAAvgGoods,
      show: false
    },
    {
      path: '/MABox/:uid/:module/:title',
      name: 'MABox',
      component: MABox,
      show: false
    },
    {
      path: '/MANew/:uid/:module/:title',
      name: 'MANew',
      component: MANew,
      show: false
    },
    {
      path: '/MADisplay/:uid/:module/:title',
      name: 'MADisplay',
      component: MADisplay,
      show: false
    },
    {
      path: '/EightyAvgGoods/:uid/:module/:title',
      name: 'EightyAvgGoods',
      component: EightyAvgGoods,
      show: false
    },
    {
      path: '/EightyGoods/:uid/:module/:title',
      name: 'EightyGoods',
      component: EightyGoods,
      show: false
    },
    {
      path: '/EightyBox/:uid/:module/:title',
      name: 'EightyBox',
      component: EightyBox,
      show: false
    },
    {
      path: '/AllStock/:uid/:module/:title',
      name: 'AllStock',
      component: AllStock,
      show: false
    },
    {
      path: '/AllDisplay/:uid/:module/:title',
      name: 'AllDisplay',
      component: AllDisplay,
      show: false
    },
    {
      path: '/CVSAvg/:uid/:module/:title',
      name: 'CVSAvg',
      component: CVSAvg,
      show: false
    },
    {
      path: '/CVSFreezer/:uid/:module/:title',
      name: 'CVSFreezer',
      component: CVSFreezer,
      show: false
    },
    {
      path: '/CVSDisplay/:uid/:module/:title',
      name: 'CVSDisplay',
      component: CVSDisplay,
      show: false
    },
    {
      path: '/CVSStock/:uid/:module/:title',
      name: 'CVSStock',
      component: CVSStock,
      show: false
    },
    {
      path: '/WorkLoad/:uid',
      name: 'WorkLoad',
      component: WorkLoad,
      show: false
    },
    {
      path: '/ToTerminal/:uid',
      name: 'ToTerminal',
      component: ToTerminal,
      show: false
    },
    {
      path: '/Performance/:uid',
      name: 'Performance',
      component: Performance,
      show: false
    },
    {
      path: '/callcarddetail/:callId',
      name: 'CallCardDetail',
      component: CallCardDetail,
      show: false
    },
    {
      path: '/kpihome/:uid/:role',
      name: 'KpiHome',
      component: KpiHome,
      show: false
    },
    {
      path: '/customerkpi/:cid',
      name: 'CustomerKpi',
      component: CustomerKpi,
      show: false
    },


    {
      path: '/ModernCoreDisplay/:uid/:module/:title',
      name: 'ModernCoreDisplay',
      component: () => import('../components/kpi/ModernCoreDisplay'),
      show: false,
      meta: {
        title: '现代-核心陈列'
      }
    },
    {
      path: '/ModernMarketRate/:uid/:module/:title',
      name: 'ModernMarketRate',
      component: () => import('../components/kpi/ModernMarketRate'),
      show: false,
      meta: {
        title: '现代-铺市率'
      }
    },
    {
      path: '/ModernDayCD/:uid/:module/:title',
      name: 'ModernDayCD',
      component: () => import('../components/kpi/ModernDayCD'),
      show: false,
      meta: {
        title: '现代-[日龄]CD杯'
      }
    },
    {
      path: '/ModernDayU/:uid/:module/:title',
      name: 'ModernDayU',
      component: () => import('../components/kpi/ModernDayXU'),
      show: false,
      meta: {
        title: '现代-[日龄]100ML优益C'
      }
    },
    {
      path: '/ModernDayGYR/:uid/:module/:title',
      name: 'ModernDayGYR',
      component: () => import('../components/kpi/ModernDayGYR'),
      show: false,
      meta: {
        title: '现代-[日龄]250冠益乳系列'
      }
    },
    {
      path: '/ModernPromotionCD/:uid/:module/:title',
      name: 'ModernPromotionCD',
      component: () => import('../components/kpi/ModernPromotionCD'),
      show: false,
      meta: {
        title: '现代-[促销]CD杯'
      }
    },
    {
      path: '/ModernPromotionU/:uid/:module/:title',
      name: 'ModernPromotionU',
      component: () => import('../components/kpi/ModernPromotionXU'),
      show: false,
      meta: {
        title: '现代-[促销]100ML优益C'
      }
    },
    {
      path: '/ModernPromotionGYR/:uid/:module/:title',
      name: 'ModernPromotionGYR',
      component: () => import('../components/kpi/ModernPromotionGYR'),
      show: false,
      meta: {
        title: '现代-[促销]100ML优益C'
      }
    },
    {
      path: '/ModernPromotionExecute/:uid/:module/:title',
      name: 'ModernPromotionExecute',
      component: () => import('../components/kpi/ModernPromotionExecute'),
      show: false,
      meta: {
        title: '现代-常规促销执行情况'
      }
    },
    {
      path: '/ModernPromotionRate/:uid/:module/:title',
      name: 'ModernPromotionRate',
      component: () => import('../components/kpi/ModernPromotionRate'),
      show: false,
      meta: {
        title: '现代-冷风柜资源占有率'
      }
    },
  ]
};

var ms = store.getMenus();
for(var m in ms) options.routes.push(ms[m]);

var router = new Router(options);

NProgress.configure({ showSpinner: false });

router.beforeEach((to, from, next) => {
  NProgress.start();

  var loginMenu = store.getCurMenu();
  if (!loginMenu && to.path != '/login') {
    next({ path: '/login' })
  } else {
    next()
  }
})

router.afterEach(transition => {
  NProgress.done();
});


export default router



// WEBPACK FOOTER //
// ./src/router/index.js